import { render, staticRenderFns } from "./Epico.vue?vue&type=template&id=3820ecb9&scoped=true"
import script from "./Epico.vue?vue&type=script&lang=js"
export * from "./Epico.vue?vue&type=script&lang=js"
import style0 from "./Epico.vue?vue&type=style&index=0&id=3820ecb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3820ecb9",
  null
  
)

export default component.exports